import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { SecurityQuestions } from './components';
import { actions as userActions } from 'store/user';
import { LoginComponent } from 'components';
import { initializeLogin } from 'store/user/actions';
const { forgotPassword, forgotUsername } = userActions;

const Forgot = props => {
  const { history } = props;
  const dispatch = useDispatch();
  const { forgotDetail } = useParams();

  const user = useSelector(store => store.user);

  const forgotUsernameSchema = {
    email: {
      presence: false,
      email: true,
      length: {
        maximum: 64
      }
    }
  };

  const forgotPasswordSchema = {
    username: {
      presence: { allowEmpty: false, message: 'is required' }
    }
  };

  const getForgotUsernameInputs = () => [
    { name: 'email', label: "Email", type: 'text' },
    { name: 'phone', label: "Phone", type: 'text', isNumber: true }
  ];

  const getForgotPasswordInputs = () => [
    { name: 'username', label: "Username", type: 'text' }
  ];

  const handleNext = (event, values) => {
    event.preventDefault();
    if (forgotDetail === 'password') {
      dispatch(forgotPassword(values.username));
    } else {
      let postData = { appTitle: 'rGuest', forgotUsernameRequest: [] };
      if (values.email && values.email.length > 0) {
        postData.forgotUsernameRequest.push({
          userContactType: 'USER_CONTACT_TYPE_EMAIL',
          value: values.email
        });
      }
      if (values.phone && values.phone.length > 0) {
        postData.forgotUsernameRequest.push({
          userContactType: 'USER_CONTACT_TYPE_SMS',
          value: values.phone
        });
      }
      dispatch(forgotUsername(postData));
    }
  };

  const handleBack = () => {
    dispatch(initializeLogin());
    history.push('/');
  };

  const getButtonGroup = () => [
    { title: 'Submit', isSubmit: true, action: (event, values) => handleNext(event, values) },
    { title: 'Go to Sign in', action: handleBack, isEnabled: true }
  ];

  const getIsDisabled = (name, values) => {
    if (name === 'email') {
      return values.phone;
    } else if (name === 'phone') {
      return values.email;
    }
  };

  return (
    <React.Fragment>
      {forgotDetail === 'username' &&
        <LoginComponent
          title={`Forgot ${forgotDetail}`}
          subTitle={'Provide  E-mail or Phone number linked to recover your username'}
          isDisabled={(name, values) => getIsDisabled(name, values)}
          inputFields={getForgotUsernameInputs()}
          buttonGroup={getButtonGroup()}
          schema={forgotUsernameSchema} />}

      {forgotDetail === 'password' &&
        (user.forgotView === 'securityQuestions' ?
          <SecurityQuestions
            user={user}
            handleBack={handleBack} />
          :
          <LoginComponent
            title={`Forgot ${forgotDetail}`}
            subTitle={'Provide correct username to recover your password'}
            inputFields={getForgotPasswordInputs()}
            buttonGroup={getButtonGroup()}
            schema={forgotPasswordSchema} />)}
    </React.Fragment>
  );
};

export default Forgot;